import { Button, Group, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core'
import { IconArrowRight, IconDeviceMobile } from '@tabler/icons-react'
import { observer } from 'mobx-react-lite'
import type { PostHog } from 'posthog-js'

import { useGlobalState } from '@/hooks/useGlobalState'
import { getAppSignInUrl } from '@/utils/sponsors'

function getPlatform(): 'ios' | 'android' | 'web' {
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Android/i.test(ua)) return 'android'
  return 'web'
}

export function captureEndUserRedirect(
  posthog: PostHog | undefined,
  params: { userId?: string; entryPoint: 'login' | 'changePassword' },
) {
  posthog?.capture('portal_end_user_redirect', {
    userId: params.userId,
    entryPoint: params.entryPoint,
    referrer: document.referrer,
    entryUrl: window.location.href,
    platform: getPlatform(),
    skPlatform: 'portal',
  })
}

export const EndUserAppRedirect = observer(function EndUserAppRedirect(props: {
  email: string
  note?: string
  onUseDifferentEmail: () => void
}) {
  const { configStore } = useGlobalState()
  const signInUrl = getAppSignInUrl(configStore.authBaseUrl, props.email)

  return (
    <Stack gap="lg">
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <ThemeIcon size="lg" radius="md" variant="light">
          <IconDeviceMobile />
        </ThemeIcon>
        <Title order={2} size="h4" fw={600}>
          Your account uses the Sidekick app
        </Title>
      </Group>

      {props.note && <Text c="dimmed">{props.note}</Text>}

      <Text c="dimmed">
        The Sidekick Platform Portal is for experts and program managers who create content. Your account is set up to
        use the Sidekick Platform app.
      </Text>

      <Paper withBorder p="sm" radius="md" bg="var(--mantine-color-gray-0)">
        <Text size="xs" c="dimmed">
          Email address
        </Text>
        <Text fw={500}>{props.email}</Text>
      </Paper>

      <Button
        size="lg"
        fullWidth
        rightSection={<IconArrowRight size={18} />}
        onClick={() => window.location.assign(signInUrl)}>
        Go to the Sidekick App
      </Button>

      <Button variant="subtle" size="compact-lg" onClick={props.onUseDifferentEmail} style={{ alignSelf: 'center' }}>
        Use a Different Email
      </Button>
    </Stack>
  )
})
